import { render, staticRenderFns } from "./menuList_dialog.vue?vue&type=template&id=6c37884e"
import script from "./menuList_dialog.vue?vue&type=script&lang=js"
export * from "./menuList_dialog.vue?vue&type=script&lang=js"
import style0 from "./menuList_dialog.vue?vue&type=style&index=0&id=6c37884e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports